import { cn } from '@/lib/utils'
import { FC, HTMLProps } from 'react'

interface ExecutionInputProps extends HTMLProps<HTMLDivElement> {
	approachValue: string
	restValue: string
	onApproachIncrease: () => void
	onApproachDecrease: () => void
	onRestIncrease: () => void
	onRestDecrease: () => void
	onApproachValueClick?: () => void
	onRestValueClick?: () => void
}

interface ControlButtonProps {
	mode: 'plus' | 'minus'
	onClick: () => void
}

const ControlButton: FC<ControlButtonProps> = ({ mode, onClick }) => (
	<button
		type='button'
		onClick={onClick}
		aria-label={mode === 'plus' ? 'Увеличить' : 'Уменьшить'}
		className='flex h-[46px] w-[46px] items-center justify-center rounded-full bg-[#F3F3F3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black'>
		<div className='relative h-[18px] w-[18px]'>
			<span className='absolute inset-0 m-auto h-[2px] w-[18px] rounded-full bg-black' />
			{mode === 'plus' && (
				<span className='absolute inset-0 m-auto h-[18px] w-[2px] rounded-full bg-black' />
			)}
		</div>
	</button>
)

interface SelectorProps {
	label: string
	value: string
	color: string
	onDecrease: () => void
	onIncrease: () => void
	onValueClick?: () => void
	valueAriaLabel: string
}

const Selector: FC<SelectorProps> = ({
	label,
	value,
	onDecrease,
	onIncrease,
	onValueClick,
	valueAriaLabel,
	color,
}) => (
	<div className='w-full rounded-[22px] border border-[#F0F0F0] bg-white px-5 py-3 shadow-[0_1px_6px_rgba(0,0,0,0.03)]'>
		<div className='text-center text-[12px] font-semibold uppercase tracking-[0.08em]' style={{ color }}>
			{label}
		</div>
		<div className='mt-1 flex w-full items-center justify-between gap-4'>
			<ControlButton mode='minus' onClick={onDecrease} />
			<button
				type='button'
				onClick={onValueClick}
				disabled={!onValueClick}
				aria-label={valueAriaLabel}
				className='min-w-[132px] rounded-[18px] px-2 py-1 text-[46px] font-medium leading-none tracking-[-0.03em] transition active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black disabled:pointer-events-none disabled:bg-transparent'>
				{value}
			</button>
			<ControlButton mode='plus' onClick={onIncrease} />
		</div>
	</div>
)

export const ExecutionInput: FC<ExecutionInputProps> = ({
	approachValue,
	restValue,
	onApproachDecrease,
	onApproachIncrease,
	onRestDecrease,
	onRestIncrease,
	onApproachValueClick,
	onRestValueClick,
	...rest
}) => {
	return (
		<div {...rest} className={cn('flex w-full flex-col gap-3', rest.className)}>
			<Selector
				color='#5664FF'
				label='Работа'
				value={approachValue}
				onDecrease={onApproachDecrease}
				onIncrease={onApproachIncrease}
				onValueClick={onApproachValueClick}
				valueAriaLabel='Выбрать время работы'
			/>
			<Selector
				color='#7F86D3'
				label='Отдых'
				value={restValue}
				onDecrease={onRestDecrease}
				onIncrease={onRestIncrease}
				onValueClick={onRestValueClick}
				valueAriaLabel='Выбрать время отдыха'
			/>
		</div>
	)
}
